define('collections/feedback',[
  "globals",
  "backbone"
], function (globals, Backbone) {
  "use strict";

  return Backbone.Collection.extend({
    url: function () {
      var location = globals.content.get("location");
      var base = $("[data-feedback-base]").data("feedback-base");
      return [ base, location.library, location.version, location.language, location.path ].join("/") + "/";
    }
  });
});

